import { styled } from '@mui/system';

export const DateRangeRoot = styled('section')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column'
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing()
  },
  alignItems: 'center',
  '& > div': {
    width: 195,
    marginLeft: theme.spacing()
  },
  '& > div:first-of-type': {
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing()
    }
  }
}));

export const pickerClassName = {
  fontSize: '0.93rem'
};
